import React from 'react';

import { nanoid } from 'nanoid';
import PropTypes from 'prop-types';

import { GroupsSelect } from '~/components/selects';

import { Container } from './styles';

function Groups({ label, id = `_select${nanoid()}`, ...props }) {
  return (
    <Container>
      <label htmlFor={id}>{label}</label>
      <GroupsSelect id={id} {...props} />
    </Container>
  );
}

Groups.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

export default Groups;
